import { httpClient } from '../../../services/http/httpClient.js';
import { buildQueryString, getCollection } from '../../../services/teams/serviceUtils.js';

const TEAM_ASSIGNMENTS_API_URL = '/api/team-assignments';

export const teamAssignmentService = {
  getAssignments: async (params = {}) => {
    const queryString = buildQueryString(params);
    const url = `${TEAM_ASSIGNMENTS_API_URL}${queryString ? `?${queryString}` : ''}`;
    const payload = await httpClient.get(url);
    return getCollection(payload, ['assignments']);
  },

  getAssignmentHistory: async (params = {}) => {
    const queryString = buildQueryString(params);
    const url = `${TEAM_ASSIGNMENTS_API_URL}/history${queryString ? `?${queryString}` : ''}`;
    const payload = await httpClient.get(url);

    return {
      history: getCollection(payload, ['history', 'items', 'data']),
      pagination: payload?.pagination || null,
      payload
    };
  },

  createAssignment: async (assignmentData) => {
    return httpClient.post(TEAM_ASSIGNMENTS_API_URL, { data: assignmentData });
  },

  updateAssignment: async (assignmentId, assignmentData) => {
    return httpClient.put(`${TEAM_ASSIGNMENTS_API_URL}/${assignmentId}`, {
      data: assignmentData
    });
  },

  deleteAssignment: async (assignmentId) => {
    return httpClient.delete(`${TEAM_ASSIGNMENTS_API_URL}/${assignmentId}`);
  }
};
